import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import withSideEffect from 'react-side-effect';
import { setPageTitle } from 'mt-react-common/reducer';

// eslint-disable-next-line dot-notation
const appName = process.env['APP_NAME'];

function reducePropsToState(propsList) {
  const innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.title;
  }
  return null;
}

function handleStateChangeOnClient(title) {
  const nextTitle = title || '';
  if (nextTitle !== document.title) {
    document.title = `${nextTitle} | ${appName}`;
    document
      .querySelector('meta[name="description"]')
      .setAttribute('content', '');
    document.querySelector('meta[name="keywords"]').setAttribute('content', '');
  }
}

const DocumentTitle = props => {
  const { title, children } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageTitle(title));
  }, []);

  if (children) {
    return React.Children.only(children);
  }
  return null;
};

DocumentTitle.displayName = 'DocumentTitle';
DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default withSideEffect(reducePropsToState, handleStateChangeOnClient)(
  DocumentTitle
);



// WEBPACK FOOTER //
// ./src/utils/DocumentTitle.js